<template>
  <div class="instance-table">
    <div class="instance-table__head">
      <table>
        <thead>
          <tr>
            <th>序号</th>
            <th>集群</th>
            <th>实例</th>
            <th>CPU使用率</th>
            <th>内存使用率</th>
            <th>磁盘使用率</th>
            <th>QMT状态</th>
            <th>操作</th>
          </tr>
        </thead>
      </table>
    </div>

    <div class="instance-table__body">
      <table>
        <tbody>
          <tr v-show="data.length" v-for="(row,index) in data" :key="index">
            <td>{{index+1}}</td>
            <td>{{row.name}}</td>
            <td>{{row.instanceID}}</td>
            <td>{{row.cpu.toFixed(1)}}%</td>
            <td>{{`${row.ram.use.toFixed(1)}/${row.ram.total.toFixed(1)}(${(row.ram.use/row.ram.total * 100).toFixed(1)}%)`}}</td>
            <td>{{`${row.disk.use.toFixed(1)}/${row.disk.total.toFixed(1)}(${(row.disk.use/row.disk.total * 100).toFixed(1)}%)`}}</td>
            <td>{{row.qmt_status}}</td>
            <td>
              <button class="instance-table__body__restart-btn" @click="handleClickRestart(row)">重启QMT</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "InstanceTable",
  data() {
    return {};
  },
  props: {
    data: Array
  },
  methods: {
    handleClickRestart(row) {
      this.$router.push({
        query: {
          apply_data: "restartQMT",
          instance: row.instanceID,
          t: +new Date()
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.instance-table {
  &__head,
  &__body {
    & table {
      width: 100%;
      text-align: left;
      font-size: 0.75rem;
      color: #9eabbe;
      border-collapse: collapse;

      & tr td:nth-child(1),
      & tr th:nth-child(1) {
        width: 5%;
      }
      & tr td:nth-child(2),
      & tr th:nth-child(2) {
        width: 15%;
      }
      & tr td:nth-child(3),
      & tr th:nth-child(3) {
        width: 15%;
      }
      & tr td:nth-child(4),
      & tr th:nth-child(4) {
        width: 10%;
      }
      & tr td:nth-child(5),
      & tr th:nth-child(5) {
        width: 17%;
      }
      & tr td:nth-child(6),
      & tr th:nth-child(6) {
        width: 17%;
      }
      & tr td:nth-child(7),
      & tr th:nth-child(7) {
        width: 13%;
      }
      & tr td:nth-child(8),
      & tr th:nth-child(8) {
        width: 8%;
      }
    }
  }

  &__head {
    & table thead {
      text-align: center;
      background-color: #1c2130;
      & tr {
        height: 2.5rem;
      }
    }
  }

  &__body {
    height: 7.5rem;
    overflow-y: auto;
    & table tbody {
      text-align: center;

      & tr {
        height: 2rem;
      }
    }

    &__restart-btn {
      padding: 2px 5px;
      font-size: 12px;
    }
  }
}
</style>